<template>
	<v-layout>
		<v-flex>
			<v-tabs 
				app
				:height="54"
				class="py-2 px-1"
				color="transparent"
				slider-color="primary"
				>
				<v-tab v-for="(tab, i) in tabs" exact :ripple="false" :to="tab.to" :key="i">
					{{ tab.text }}
				</v-tab>        
			</v-tabs>
			<div id="mainTabs" ref="main" style="display: flex; flex-direction: column !important; height: 91%;">
				<v-slide-y-reverse-transition >
					<router-view v-show="!$store.getters.progress" :key="$route.fullPath"></router-view>
				</v-slide-y-reverse-transition>
			</div>
			</v-flex>
	</v-layout>
</template>

<script>
export default {
	name: 'app-tabs',
	props: {
		tabs: Array,
		propStyle: Object
	},
	computed: {
		tabStyle() {
			if (this.propStyle) {
				return this.style
			}
		}
	},

	data() {
		return {
			style: {
				display: 'flex;',
				'flex-direction': 'column !important;',
				height: '91%;'
			}
		}
	}
}
</script>
<style>
</style>
